import { forwardRef } from 'react'
import { CheckBoxOutlineBlank, Delete, DragHandle, ExpandMore } from '@mui/icons-material'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import { Box } from '@mui/system'
import PropTypes from 'prop-types'

import { MiscItemIcon } from '@/common/icons'

const classes = {
    Overlay: {
        borderRadius: 2,
        overflow: 'hidden',
        backgroundColor: 'primary.main',

        boxShadow: 15,
        zIndex: 10,
    },

    OverlayContent: {
        px: 2,
        py: 1.5,
        display: 'flex',
        justifyContent: 'space-between',
        height: 74,
    },

    OverlayContentLeft: {
        gap: 1.5,
    },

    OverlayContentRight: {
        gap: 6,
    },

    OverlayContentColor: {
        color: 'primary.contrastText',
    },
}

const MiscellaneousItemOverlay = forwardRef(({ id, name, ...props }, ref) => {
    return (
        <Box sx={classes.Overlay}>
            <Box sx={classes.OverlayContent}>
                <Box
                    sx={[
                        {
                            alignItems: 'center',
                            display: 'flex',
                        },
                        classes.OverlayContentLeft,
                    ]}
                >
                    <IconButton
                        size="small"
                        sx={classes.OverlayContentColor}
                    >
                        <DragHandle />
                    </IconButton>

                    <CheckBoxOutlineBlank
                        fontSize="small"
                        sx={classes.OverlayContentColor}
                    />

                    <Box
                        sx={{
                            alignItems: 'center',
                            display: 'flex',
                            gap: 2,
                        }}
                    >
                        <MiscItemIcon />
                        <Typography sx={classes.OverlayContentColor}>{name}</Typography>
                    </Box>
                </Box>

                <Box
                    sx={[
                        {
                            alignItems: 'center',
                            display: 'flex',
                        },
                        classes.OverlayContentRight,
                    ]}
                >
                    <Box
                        sx={{
                            alignItems: 'center',
                            display: 'flex',
                        }}
                    >
                        <IconButton sx={classes.OverlayContentColor}>
                            <Delete />
                        </IconButton>

                        <ExpandMore sx={classes.OverlayContentColor} />
                    </Box>
                </Box>
            </Box>
        </Box>
    )
})

MiscellaneousItemOverlay.displayName = 'QuoteItemOverlay'

MiscellaneousItemOverlay.propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
}

export default MiscellaneousItemOverlay
